
import { defineComponent, ref, reactive } from 'vue';
import { Coin } from '@element-plus/icons'
export default defineComponent({
    components: {
Coin

    },
    setup () {

        return {


        };
    },
});
